import { Box, Chip } from "@common-ui/ui";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";
import SyncIcon from "@mui/icons-material/Sync";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { chipClasses } from "@mui/material";
import { CheckCircle, DoNotDisturbOn } from "@mui/icons-material";
import WrapTextOutlinedIcon from "@mui/icons-material/WrapTextOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

export const statusCodes = {
  DRAFT: {
    color: "#9e9e9e",
    backgroundColor: "#eeeeee",
    icon: <NoteAltIcon />,
  },
  NOT_STARTED: {
    color: "#424242",
    backgroundColor: "#e0e0e0",
    icon: <HourglassTopIcon />,
  },
  IN_PROGRESS: {
    color: "#1e88e5",
    backgroundColor: "#e3f2fd",
    icon: <SyncIcon />,
  },
  ON_HOLD: {
    color: "#f57f17",
    backgroundColor: "#ffccbc",
    icon: <PauseCircleIcon />,
  },
  PENDING: {
    color: "#856b1a",
    backgroundColor: "#f8e9bd",
    icon: <WatchLaterIcon />,
  },
  IN_REVIEW: {
    color: "#856b1a",
    backgroundColor: "#f8e9bd",
    icon: <ContentPasteSearchIcon />,
  },
  COMPLETED: {
    color: "#31a975",
    backgroundColor: "#daf3e3",
    icon: <CheckCircleOutlineIcon />,
  },
  CANCELLED: {
    color: "#ce504d",
    backgroundColor: "#fbdce3",
    icon: <HighlightOffIcon />,
  },
  PASS: {
    color: "#22A16B",
    backgroundColor: "#D8F1E6",
    icon: <CheckCircle />,
  },
  FAIL: {
    color: "#c62828",
    backgroundColor: "#fbdce3",
    icon: <CancelOutlinedIcon />,
  },
  WARN: {
    color: "#ff9800",
    backgroundColor: "#fff4e5",
    icon: <ErrorOutlineOutlinedIcon />,
  },
  SKIPPED: {
    color: "#1e88e5",
    backgroundColor: "#e3f2fd",
    icon: <WrapTextOutlinedIcon />,
  },
  DEFAULT: {
    color: "#424242",
    backgroundColor: "#e0e0e0",
    icon: <DoNotDisturbOn />,
  },
};

export const StatusChip = ({ status }) => {
  return (
    <Chip
      icon={statusCodes[status].icon}
      size="small"
      label={
        <div style={{ textTransform: "capitalize" }}>
          {status.replaceAll("_", " ")}
        </div>
      }
      sx={{
        borderColor: statusCodes[status].color,
        color: statusCodes[status].color,
        backgroundColor: statusCodes[status].backgroundColor,
        [`& .${chipClasses.icon}`]: {
          color: statusCodes[status].color,
        },
      }}
      // variant="filed"
    />
  );
};

export const IconButtonComponent = ({ status }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      sx={{
        p: 1.5,
        m: 0.5,
        borderRadius: "50%",
        color: statusCodes[status].color,
        backgroundColor: statusCodes[status].backgroundColor,
      }}
    >
      {statusCodes[status].icon}
    </Box>
  );
};
